/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_CopiedInputs */

const en_settings_apikeys_copied = /** @type {(inputs: Settings_Apikeys_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Copied to clipboard" |
*
* @param {Settings_Apikeys_CopiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_copied = /** @type {((inputs?: Settings_Apikeys_CopiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_CopiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_copied(inputs)
});
export { settings_apikeys_copied as "settings.apikeys.copied" }